import { createTestIds } from '@pega/cosmos-react-core';

export const getDynamicContentEditorTestIds = createTestIds('dynamic-content-editor', [
  'insert-field',
  'insert-field-modal',
  'insert-field-modal-cancel',
  'insert-field-modal-submit'
] as const);
